import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaService } from '../../../core/services/pwa.service';
import { GlassCardComponent } from '../glass-card/glass-card.component';

@Component({
  selector: 'app-offline-indicator',
  standalone: true,
  imports: [CommonModule, GlassCardComponent],
  template: `
    @if (!isOnline()) {
      <app-glass-card tint="strong" padding="sm" class="offline-indicator" role="status" aria-live="polite">
        <div class="offline-indicator__content">
          <img src="/assets/icons/plumpy-wifi-off.png" alt="آفلاین" class="offline-indicator__icon icon-plumpy" />
          <span class="offline-indicator__text">شما آفلاین هستید. تغییرات به محض اتصال مجدد همگام‌سازی می‌شوند.</span>
        </div>
      </app-glass-card>
    }
  `,
  styles: [`
    .offline-indicator {
      position: fixed;
      top: var(--space-md);
      left: var(--space-md);
      right: var(--space-md);
      max-width: 480px;
      margin-inline: auto;
      z-index: 1000;
      animation: slide-down 0.3s var(--ease-out-spring) both;
    }

    @keyframes slide-down {
      from { opacity: 0; transform: translateY(-100%); }
      to { opacity: 1; transform: translateY(0); }
    }

    .offline-indicator__content {
      display: flex;
      align-items: center;
      gap: var(--space-sm);
    }

    .offline-indicator__icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      opacity: 0.8;
    }

    .offline-indicator__text {
      font-size: 0.82rem;
      color: var(--text-on-glass-strong);
      @include mixins.text-caption;
      font-weight: 500;
    }
  `],
})
export class OfflineIndicatorComponent implements OnInit, OnDestroy {
  private readonly pwaService = inject(PwaService);

  isOnline = signal(true);

  ngOnInit(): void {
    this.pwaService.isOnline$.subscribe((online) => this.isOnline.set(online));
  }

  ngOnDestroy(): void {}
}